import React, { useEffect } from 'react';
import { Support } from '../../hooks/Support';
import Hls from 'hls.js';

declare global {
  interface HTMLElement {
    webkitSetPresentationMode?: (type: string) => Promise<void>;
    requestPictureInPicture?: () => Promise<void>;
    exitPictureInPicture?: () => Promise<void>;
  }
}

export type PipProps = {
  enabled: boolean;
  hls: Hls;
  code: string;
  supported: Support;
};

const Pip = ({ enabled, hls, code, supported }: PipProps) => {
  const [isPip, setIsPip] = React.useState<boolean>(false);

  const pictureInPicture = () => {
    const toggle = !isPip;

    if (!hls.media) {
      return;
    }

    // Toggle based on current state
    // Safari
    if (hls.media.webkitSetPresentationMode) {
      hls.media.webkitSetPresentationMode(toggle ? 'picture-in-picture' : 'inline');
      return;
    }

    // Chrome
    if (hls.media.requestPictureInPicture) {
      if (toggle) {
        hls.media.requestPictureInPicture();
      } else if (!toggle) {
        document.exitPictureInPicture();
      }
    }
  };

  const onEnterPictureInPicture = () => {
    setIsPip(true);
  };

  const onLeavePictureInPicture = () => {
    setIsPip(false);
  };

  useEffect(() => {
    if (!hls || !hls.media) {
      return;
    }

    hls.media.addEventListener("enterpictureinpicture", onEnterPictureInPicture);
    hls.media.addEventListener("leavepictureinpicture", onLeavePictureInPicture);

    return () => {
      if (!hls || !hls.media) {
        return;
      }

      hls.media.removeEventListener("enterpictureinpicture", onEnterPictureInPicture);
      hls.media.removeEventListener("leavepictureinpicture", onLeavePictureInPicture);
    };
  }, [hls]);

  return enabled ? (
    <div className={`smartplayer__pip ${isPip ? 'smartplayer__pip--active' : 'smartplayer__pip--inactive'}`} onClick={() => pictureInPicture()}>
      <button className="smartplayer__bar-button" type="button" disabled={!supported.pip}>
        <div className="icon icon--pip-active">
          <div className="subicon subicon--wide">
            <svg xmlns="http://www.w3.org/2000/svg" height="32" width="40" viewBox="0 0 640 512" fill="currentColor">
              <path d="M576 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"/>
            </svg>
            <div className="subicon subicon--complete-box">
            </div>
          </div>
        </div>
        <div className="icon icon--pip-inactive">
          <div className="subicon subicon--wide">
            <svg xmlns="http://www.w3.org/2000/svg" height="32" width="40" viewBox="0 0 640 512" fill="currentColor">
              <path d="M576 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"/>
            </svg>
            <div className="subicon subicon--wide-box">
            </div>
          </div>
        </div>
      </button>
    </div>
  ) : null;
};

export default Pip;
